import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/app/analize/[category]/[slug]/MobileCollapsibleSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/nextjs/src/components/MyTestButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/components/TableOfContents.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/nextjs/src/components/Tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
